var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHouseSimple = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 94 104",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M91.27 34.44 51.334 3.375 47 0l-4.338 3.375L2.73 34.44 0 36.566v55.447c0 6.613 5.354 11.991 11.937 11.991H82.06c6.584 0 11.937-5.378 11.937-11.991V36.562l-2.73-2.125.003.003Zm-33.2 62.484H37.104V56.478H58.07v40.446Zm28.861-4.915c0 2.715-2.182 4.915-4.872 4.915H65.135V49.402H30.032v47.522H11.933c-2.69 0-4.872-2.2-4.872-4.915V40.026L47 8.961l39.931 31.065v51.983Z",
  fill: "currentColor"
})));
export default SvgHouseSimple;